import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { APIList } from 'src/interfaces'
import { Entities } from 'src/enums'
import { ProductRequest } from 'src/api'
import { useApiInstance } from './useApiInstance'
import {
  buildRequestParams,
  ObjectType,
  transformPage,
  transformPerPage,
} from './helpers'

interface RequestParams {
  params?: Partial<GetParams>;
  paramsTransform?: Array<(params: Record<string, any>) => Record<string, any>>;
  options?: Omit<
    UseQueryOptions<APIList<ProductRequest>, Error>,
    'queryKey' | 'queryFn'
  >;
}

interface GetParams {
  limit: number;
  offset: number;
  sort: string;
}

const schema: ObjectType['schema'] = {
  limit: 'number',
  offset: 'number',
  sort: 'string',
}

export const useProductRequestListRequest = ({
  params = {},
  paramsTransform = [],
  options,
}: RequestParams = {}) => {
  const api = useApiInstance()

  const transformedParams = [
    transformPerPage,
    transformPage,
    ...paramsTransform,
  ].reduce((param, transform) => transform(param), params)

  const queryParams = buildRequestParams<GetParams>(
    transformedParams,
    schema,
  )

  return useQuery<APIList<ProductRequest>, Error>(
    [Entities.ProductRequest, JSON.stringify(transformedParams)],
    async () => {
      const {
        limit,
        offset,
        sort,
      } = queryParams
      const { data } = await api.v1AdminProductsRequestsGet(
        limit,
        offset,
        sort,
      )
      return data as APIList<ProductRequest>
    },
    {
      enabled: Object.keys(transformedParams).length > 0,
      ...options,
    },
  )
}
